import {Pipe, PipeTransform} from '@angular/core';

/**
 * The row ids a `lib-table` reports as selected, minus the ones that are not ids.
 *
 * `tablemodule` collects them by walking its selection matrix and pushing `+rowId` at every leaf.
 * An empty table has no leaves, so the walk falls straight through to the root — where `rowId` is
 * `undefined` and `+undefined` is `NaN`. Tick the header checkbox over no rows and the table
 * reports one selection that is not a row: the count reads 1, the actions turn on, and the id
 * reaches the URL as `null`, since that is what `JSON.stringify` makes of `NaN`.
 *
 * Both the count shown and whatever enables an action should run through this, so the two agree.
 */
export function realSelectedIds(ids: number[] | null | undefined): number[] {
  return (ids ?? []).filter(id => Number.isFinite(id));
}

@Pipe({
  name: 'selectedIds',
  standalone: false
})
export class SelectedIdsPipe implements PipeTransform {

  transform(ids: number[] | null | undefined): number[] {
    return realSelectedIds(ids);
  }

}
